import { InjectionToken, Provider } from '@angular/core';
import { environment } from '@environments/environment';
import { ActivityApiServiceMock } from '@mocks/activity-api-mock.service';
import { ActivityApiService } from '../activity-api.service';
import { ActivityRepository } from '../activity.repository';

export const HTTP_ACTIVITY_SERVICE = new InjectionToken<ActivityRepository>('ActivityRepository');

export const ACTIVITY_API_PROVIDER: Provider = {
    provide: HTTP_ACTIVITY_SERVICE,
    useClass: environment.useMocks && environment.useMocks.activity ? ActivityApiServiceMock : ActivityApiService,
};
